import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router';
import styled from '@emotion/styled';

import Page from '../../../components/Page/Page';
import PageBanner from '../../../components/Banner/PageBanner';
import PaginationControl from '../../../components/PaginationControl/PaginationControl';
import { useAppSelector } from '../../../redux/store';
import { useInvitedJobsSearch } from '../../../context/InvitedJobsSearchContext';

import InvitedJobSearchForm from './InvitedJobSearchForm/InvitedJobSearchForm';
import InvitedJobList from './InvitedJobList/InvitedJobList';
import InvitedJobInfo from './InvitedJobInfo/InvitedJobInfo';
import { BOOKMARKS } from '../../../routes/routeConstants';
import BackToJobListButton from '../../../components/BackToJobListButton/BackToJobListButton';

const InvitedJobsContent: React.FC = () => {
  const navigate = useNavigate();
  const { loading, page, setPage } = useInvitedJobsSearch();
  const totalPages = useAppSelector((state) => state.invitedJobs.totalPages);

  const [showMobileInfo, setShowMobileInfo] = useState(false);

  const handlePageChange = useCallback(
    (newPage: number) => {
      setPage(newPage.toString());
      if (window.innerWidth < 885) setShowMobileInfo(false);
    },
    [setPage]
  );

  return (
    <Page title="Invited Jobs">
      <Shell>
        <PageBanner
          label="Invited Jobs"
          description="Browse jobs you've been invited to apply for"
        />

        <InvitedJobSearchForm showMobileInfo={showMobileInfo} />
        <NavArea>
          <BackToJobListButton
            showMobileInfo={showMobileInfo}
            setShowMobileInfo={setShowMobileInfo}
          />
          <GoToBookmark onClick={() => navigate(`/${BOOKMARKS}`)}>
            Go to Bookmarks
          </GoToBookmark>
        </NavArea>

        <Container>
          {' '}
          <JobViewArea>
            <InvitedJobList
              showMobileInfo={showMobileInfo}
              setShowMobileInfo={setShowMobileInfo}
              loading={loading}
            />
            <InvitedJobInfo showMobileInfo={showMobileInfo} />
          </JobViewArea>
          <PaginationShell>
            <PaginationControl
              endPage={totalPages > 0 ? totalPages : 1}
              changePage={handlePageChange}
              defaultNumOfPagination={5}
              currentPage={parseInt(page, 10)}
            />
          </PaginationShell>
        </Container>
      </Shell>
    </Page>
  );
};

export default InvitedJobsContent;

// ------ Styled Components ------

const Shell = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 54px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  background-color: ${({ theme }) => theme.palette.backgroundColor};
  padding: 2rem;
  border-radius: 0.75rem;

  @media (max-width: 1024px) {
    padding: 0;
    margin-left: -30px;
    margin-right: -30px;
  }

  @media (max-width: 884px) {
    margin-left: 0;
    margin-right: 0;
  }

  @media (max-width: 540px) {
    /* border: 1px solid yellow; */
    padding: 20px;
    border-radius: 0;
    // background-color: white;
    background-color: ${({ theme }) => theme.palette.backgroundColor};
    margin-left: -20px;
    margin-right: -20px;
  }

  @media (max-width: 480px) {
    overflow: hidden;
  }
`;

const JobViewArea = styled.div`
  display: grid;
  grid-template-columns: 316px 1fr;
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: 300px 1fr;
  }

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;

const PaginationShell = styled.div`
  display: grid;
  place-content: center;
  grid-column: span 2;

  @media (max-width: 884px) {
  }
`;

const NavArea = styled.div`
  display: flex;
  margin-top: 20px;
`;

const GoToBookmark = styled.div`
  /* border: 1px solid red; */
  margin-left: auto;
  font-weight: 500;
  font-size: 18px;
  font-weight: 500;
  color: #2f80ed;
  cursor: pointer;

  @media (min-width: 885px) {
    display: none;
  }
`;
